import { z } from "zod";

export const slopeStatsSchema = z
  .object({
    category: z.string(),
    percentage: z.number(),
  })
  .array();
